// Source: https://play.tailwindcss.com/8JBYxJA7yY?file=css
module.exports = () => ({
  ".dl": {
    "@apply ds-grid ds-grid-cols-1 md:ds-grid-cols-2 ds-relative ds-border-t ds-border-tertiary-lightgrey ds-py-[1rem] ds-font-medium ds-items-center": true,
  },
  ".dd": {
    "@apply ds-flex ds-flex-row ds-justify-between": true,
  },
  ".dt": {
    "@apply ds-text-xs md:ds-text-base": true,
  },
  ".dt small": { "@apply ds-block ds-text-xs": true },
  ".dl > button.icon": { "@apply ds-absolute ds-right ds-top": true },
  ".dl:last-child": {
    "@apply ds-border-b ds-border-tertiary-lightgrey": true,
  },
});
